/**
 * 
 * @param {string} native 'Native'
 * @param {string} name -函数名称 app事件
 * @param {object} param -请求参数{ params: {}, callbackfunc: "webcallback web事件 回调函数 需要挂载到window上面" }
 * @returns webcallback(res){{res为app返回值}
 */
function callApp(native, name, param) {
  if(process.env.NODE_ENV=='development') return
  var params = {"function": name,"parameters": param}
  if (/android/i.test(navigator.userAgent)) {
    return window[native][name](JSON.stringify(params));
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    return window.webkit.messageHandlers[native].postMessage(params)
  }
}

export default {
  callApp: callApp
}


// WEBPACK FOOTER //
// ./src/utils/callApp.js